'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.extractPrefixedAttributesFromElement = extractPrefixedAttributesFromElement;

var _stringUtility = require('@nimius/string-utility');

var _objectUtility = require('@nimius/object-utility');

/**
 * @typedef {Object} extractPrefixedAttributesFromElement~Options
 * @property {boolean} [noCaseConversion = false] - Disables the conversion of kebab-case to camelCase.
 * @property {boolean} [shallow = false] - Disables dot notation for deep objects.
 */

/**
 * @description Extracts all attributes of a DOM Element with the given prefix
 * @summary
 * This method extracts all Attributes of a DOM Element that start with a given prefix and returns an Object
 * based on those values. kebab-case will be converted to camelCase and dot-notation can be used to create
 * deep objects.
 *
 * The strings may be prefixed with java-style casting syntax (type in brackets) to cast the values to
 * the correct type. For more information about string casting {@see string-utility}
 * Supported types are:
 * - int, integer
 * - float
 * - bool, boolean
 * - string
 *
 *
 * @example
 * // HTML:
 * // <div  data-swiper class="mySwiper"
 * //       data-swiper-speed="(int) 300"
 * //       data-swiper-nested="(bool) false"
 * //       data-swiper-autoplay="(int) 10000"
 * //       data-swiper-something-camel-cased="something"
 * //       data-swiper-something-deep.deep-setting="nested"
 * //       data-swiper-an-array.0.element="(int) 6.6"> ... </div>
 *
 * import { extractPrefixedAttributesFromElement } from '@nimius/dom-utility';
 * extractPrefixedAttributesFromElement(element, 'data-swiper-');
 * // => returns
 * {
 *      speed: 300,
 *      nested: false,
 *      autoplay: 10000,
 *      somethingCamelCased: 'something',
 *      somethingDeep: {
 *          deepSetting: 'nested'
 *      },
 *      anArray: [ { element: 6 } ],
 * }
 *
 *
 * @example
 * // HTML:
 * // <div data-my-configuration-with-hyphens="test"
 * //      data-my-dot.notation="(bool) false">...</div>
 *
 * import { extractPrefixedAttributesFromElement } from '@nimius/dom-utility';
 * extractPrefixedAttributesFromElement(element, 'data-my', { noCaseConversion: true, shallow: true });
 * // => returns
 * {
 *      'configuration-with-hyphens': 'test',
 *      'dot.notation': false
 * }
 *
 *
 * @param {HTMLElement} element
 * @param {string} prefix
 * @param {extractPrefixedAttributesFromElement~Options} [options]
 * @returns {Object}
 */
function extractPrefixedAttributesFromElement(element, prefix) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var attributes = {};

    for (var i = 0; i < element.attributes.length; i++) {
        var key = element.attributes.item(i).name;
        var value = element.attributes.item(i).value;

        // skip all attributes that do not have the data-swiper- prefix
        if (key.indexOf(prefix) !== 0) {
            continue;
        }

        // prepare the key
        key = key.substr(prefix.length);
        if (!options.noCaseConversion) {
            key = (0, _stringUtility.convertToCamelCase)(key, /[-_]/);
        }

        // prepare the value
        value = (0, _stringUtility.castString)(value);

        if (options.shallow) {
            attributes[key] = value;
        } else {
            (0, _objectUtility.deepSet)(attributes, key, value);
        }
    }

    return attributes;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nimius/dom-utility/src/extract-prefixed-attributes-from-element.js
// module id = 62
// module chunks = 0 2